import React, {Component, Fragment} from 'react';
// import styled from "styled-components";

import styled from "styled-components";

import {Block, Divider, Tabs} from "reakit";
import {ColumnIcon, GridIcon} from "../../components/Base/Icons";
import FilterDropdown from "../../components/Search/FilterDropdown";
import UserList from '../../components/UserList'
import SearchInput from '../../components/Forms/SearchInput'
import StudentSummary from "../../components/StudentSummary";
import {Box, Card, Flex, Heading, Text} from 'rebass';
import {Content, DesktopBox, MobileHeader, TabHeader, Toolbar} from "../../components/Base";

import Loading from '../../components/Base/Loading'
import {LiveCheckinCard} from "../../components/Cards";
import Checkin from '../Search/Checkin'

import {filterStudentsByName, returnFilterString, returnWithRosterFilterString} from "../../utils";

// import {Circle} from "styled-spinkit";
/* icon imports */
const SidebarWrapper = styled(Card)`
min-width: 250px;
	height: calc(100vh - 131px);
	margin-bottom: 10px;
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  @media(max-width: 700px){
  	height: 70vh;

  }
`;

const SidebarBox = styled(Box)`
min-width: 250px;

`

export const VerticalScroll = styled(Flex)`
  display: flex; /* [1] */
  flex-direction: row;
  flex-wrap: wrap; /* [1] */
  overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}`

class CheckinPage extends Component {

	state = {
		loading: true,
		currentCheckin: null,
		showCheckin: false,
		myCheckinList: [],
		liveCheckinList: [],
		pastCheckinList: [],
		title: 'Check In',
		currentStudent: null,
		columnView: false,
		detailsView: false,
		isCheckin: true,
		draftCheckIn: [],
		width: 0,
		height: 0,
		isStudenSummary: false,
		isLoading: false
	}

	componentDidMount() {
		const {isFaculty} = this.props;
		this.myCheckinListener = this.returnMyCheckinListener()
		this.updateWindowDimensions();
		if(isFaculty){
			this.liveCheckinListener = this.returnLiveCheckinListener()
			this.pastCheckinListener = this.returnPastCheckinListener()
		} else {
			this.liveCheckinListener = this.returnLiveActiveMyDormCheckinListener()
		}
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	returnMyCheckinListener = () => {
		const {profile} = this.props;

		return this.props.firebase.checkins().where('creator_uid', '==', profile.id).orderBy('created_at','desc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => {(result.push({id: doc.id, ...doc.data()}))});
			this.setState({myCheckinList: result, loading: false})
		})
	}

	returnLiveActiveMyDormCheckinListener = () => {
		const {profile} = this.props;
		return this.props.firebase.checkins().where('live', '==', true).where('type','==',2).where('type_id','==',profile.sub_dorm).where('active', '==', true).orderBy('created_at','desc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => {(result.push({id: doc.id, ...doc.data()}))});
			this.setState({liveCheckinList: result})
		})
	}

	returnLiveCheckinListener = () => {
		return this.props.firebase.checkins().where('live', '==', true).where('active', '==', true).orderBy('created_at','desc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => {(result.push({id: doc.id, ...doc.data()}))});
			this.setState({liveCheckinList: result})
		})
	}

	returnPastCheckinListener = () => {
		return this.props.firebase.checkins().where('active', '==', false).where('live','==',true).orderBy('created_at','desc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => {(result.push({id: doc.id, ...doc.data()}))});
			this.setState({pastCheckinList: result})
		})
	}

	handleSelectCheckin = async (item) => {
		const {school} = this.props;
		const title = await this.returnCheckinTitle(item, school)
		this.setState({currentCheckin: item, showCheckin: true, title})
	}

	returnCheckinTitle = async (checkin, school) => {
		const {firebase} = this.props;
		let result = ''
		if(checkin.type === 0){
			result = returnFilterString(checkin.filters, school)
			if(checkin.rosterFilter) {
				result = returnWithRosterFilterString(checkin.rosterFilter, result);
			}
		}
		if(checkin.type === 1){
			const roster = await firebase.roster(checkin.type_id).get()
			const data = roster.data();
			result = data && data.name;
		}
		if(checkin.type === 3){
			let dorm = school.subDormMap[checkin.item_id]
			if(dorm){
				result = dorm.name
			}
		}
		return result
	}

	handleCheckinDiscard = () => {
		const {currentCheckin} = this.state;
		const {clearFilter} = this.props;
		clearFilter()
		if (currentCheckin !== null) {
			this.setState({currentCheckin: null})
		}
	};

	handleUpdateCheckin = async (selected, dutyLog = '') => {
		const { firebase} = this.props;
		const {currentCheckin} = this.state;
		// if (isFaculty) {
			try {
				let checkinRef = firebase.checkins().doc(currentCheckin.id);


				checkinRef.update({
					present: selected,
					duty_log: dutyLog,
					updated_at: Math.floor(Date.now() / 1000)
				});
				let newCheckin = await checkinRef.get();
				this.setState({currentCheckin: {id: newCheckin.id, ...newCheckin.data()}})
				return true
			} catch (e) {
				console.log("Error saving checkin: ", e)
				return false
			}
		// }
	};

	componentWillUnmount() {
		const {isFaculty} = this.props;

		this.myCheckinListener()
		this.liveCheckinListener()

		if(isFaculty){
			this.pastCheckinListener()
		}
	}

	render() {
		const {loading, myCheckinList, liveCheckinList, pastCheckinList, isStudenSummary } = this.state;
		const { profile, isFaculty, loadingSchool, schoolInfo} = this.props;

		let isLoading = true
		if(loading === false && loadingSchool === false){
			isLoading = false
		}
		const activeCheckin = [];
		const inactiveCheckin = [];
		myCheckinList.map(checkin => {
			if (checkin.active) {
				activeCheckin.push(checkin);
			} else {
				inactiveCheckin.push(checkin);
			}
			return true;
		});

		return (
			<Box>
				{isStudenSummary ? this.renderStudentSummary() : (

					<Tabs.Container>
						{(tabs) => (
							<Block>
								<MobileHeader>
									<Heading pt={2}>Check In</Heading>
									<Tabs>
										<Tabs.Tab
											tab="current"
											{...tabs}
										>
											<TabHeader title={'Current'}/>

										</Tabs.Tab>
										<Tabs.Tab
											tab="past"
											{...tabs}
										>
											<TabHeader title={'Past'}/>

										</Tabs.Tab>
									</Tabs>
								</MobileHeader>

								<DesktopBox>
									<Tabs>
										<Tabs.Tab
											tab="current"
											{...tabs}
										>
											<TabHeader title={'Current'}/>

										</Tabs.Tab>
										<Tabs.Tab
											tab="past"
											{...tabs}
										>
											<TabHeader title={'Past'}/>

										</Tabs.Tab>
									</Tabs>
								</DesktopBox>


								<Content  px={[0, 3]}>
									{isLoading ? <Loading/>
										:
										<Box >

											{/* CURRENT Checkins*/}
											<Tabs.Panel tab="current" {...tabs} >
												<Box p={[0,3]}>
												<DesktopBox ml={1}>
													<Text fontSize={'32px'} pt={3} fontWeight={800} lineHeight={1}>My Check In</Text>

													<Text pt={2} pb={3} fontSize={'16px'} ml={'1px'} fontWeight={400} >Check Ins created by you</Text>

												</DesktopBox>
												<Box pt={[0, 2]}>
												{!activeCheckin.length && !liveCheckinList.filter(checkin => checkin.creator_uid !== profile.id).length ?(<Text pt={2} pb={3} fontSize={'16px'} fontWeight={400}>There are currently no Check Ins.</Text>):null}
												<VerticalScroll>
													{activeCheckin.map(item =>
														<Box 
															key={item.id} 
															p={'10px'}
															onClick={() => this.handleSelectCheckin(item)}
															width={[1, 1, 1 / 2 , 1 / 3]}	
														>
															<LiveCheckinCard checkin={item} schoolInfo={schoolInfo} profile={profile} isFaculty={isFaculty}/> 
														</Box>
													)}
												</VerticalScroll>
											
												</Box>
												{liveCheckinList.length > 0 &&
												<DesktopBox ml={1}>

													<Text fontSize={'32px'} pt={3} fontWeight={800} lineHeight={1}>Other Check ins</Text>

													<Text pt={2} pb={3} fontSize={'16px'} ml={'1px'} fontWeight={400} >Live Check Ins created by other people</Text>

												</DesktopBox>
												}

												<VerticalScroll>
													{liveCheckinList.filter(checkin => checkin.creator_uid !== profile.id).map(item =>
														<Box 
															key={item.id} 
															p={'10px'}
															onClick={() => this.handleSelectCheckin(item)} 
															width={[1, 1, 1 / 2 , 1 / 3]}	
														>
															<LiveCheckinCard checkin={item} type={'post'} schoolInfo={schoolInfo}/>
															<Box width={[1, 0.95]} pr={1}><Divider margin={0} padding={0} zIndex={"-9999"}/></Box>
														</Box>
													)}
												</VerticalScroll>
												</Box>
											</Tabs.Panel>


											{/* PAST Checkins*/}
											<Tabs.Panel tab="past" {...tabs} >
											<Box p={[0,3]}>
												<DesktopBox ml={1}>
													<Text fontSize={'32px'} pt={3} fontWeight={800} lineHeight={1}>My Check In</Text>

													<Text pt={2} pb={3} fontSize={'16px'} ml={'1px'} fontWeight={400} >Check Ins created by you</Text>

												</DesktopBox>
												<Box pt={[0, 2]}>
												{!inactiveCheckin.length && !pastCheckinList.filter(checkin => checkin.creator_uid !== profile.id).length ?(<Text pt={2} pb={3} fontSize={'16px'} fontWeight={400}>There are currently no Check Ins.</Text>):null}
												<VerticalScroll>
													{inactiveCheckin.map(item =>
														<Box 
															key={item.id} 
															p={'10px'}
															width={[1, 1, 1 / 2 , 1 / 3]}	
															onClick={() => this.handleSelectCheckin(item)}
														>
															<LiveCheckinCard checkin={item} schoolInfo={schoolInfo}/>
														</Box>
													)}
												</VerticalScroll>
												</Box>

												{pastCheckinList.filter(checkin => checkin.creator_uid !== profile.id).length > 0 &&
												<DesktopBox ml={1}>

													<Text fontSize={'32px'} pt={3} fontWeight={800} lineHeight={1}>Other Check ins</Text>

													<Text pt={2} pb={3} fontSize={'16px'} ml={'1px'} fontWeight={400} >Live Check Ins created by other people</Text>

												</DesktopBox>
												}
												<VerticalScroll>
													{pastCheckinList.filter(checkin => checkin.creator_uid !== profile.id).map(item =>
														<Box 
															key={item.id} 
															px={1} 
															onClick={() => this.handleSelectCheckin(item)}
															width={[1, 1, 1 / 2 , 1 / 3]}	
														>
															<LiveCheckinCard checkin={item} type={'post'} schoolInfo={schoolInfo}/>
															<Box width={[1, 0.95]} pr={1}><Divider margin={0} padding={0} zIndex={"-9999"}/></Box>
														</Box>
													)}
												</VerticalScroll>
											</Box>
											</Tabs.Panel>
										</Box>
									}

								</Content>
							</Block>
						)}
					</Tabs.Container>
				)}
				{this.renderCheckin()}
			</Box>
		);
	}

	handleSelectStudent = async (details, isCheckin = false, selectedItems = []) => {
		const {width, history} = this.state;
		if (isCheckin) {
			this.setState({
				isLoading: true
			})
	
		}
		if (width < 700 && true) {
			history.push(`/app/profile/${details.id}`)
		} else {
			try {
				let studentRef = this.props.firebase.student(details.id);
				let leavesRef = await this.props.firebase.leaves().where('student_uid', '==', details.id).orderBy('start_date', 'asc').get();
				let leaveResult = [];
				let waveResult = [];
				let waveRef = await studentRef.collection('wave_history').orderBy('post_time').get();
				leavesRef.docs.forEach(doc => leaveResult.push({id: doc.id, ...doc.data()}));
				waveRef.docs.forEach(doc => waveResult.push({id: doc.id, ...doc.data()}));
				details.leaves = leaveResult;
				details.wave = waveResult;

				if (isCheckin) {
					this.setState({
						checkin: false,
						isCheckin: false,
						draftCheckIn: selectedItems,
						currentStudent: details,
						detailsView: true,
						showCheckin: false,
						isStudenSummary: true,
						isLoading: false
					})
				} else {
					this.setState({
						currentStudent: details,
						detailsView: true
					});
				}
			} catch (err) {
				console.log('failed to fetch student: ', err)
			}
		}
	};

	renderStudentSummary = () => {
		const { currentStudent, columnView, detailsView, isLoading } = this.state;
		const {search, profile, loading, students, schoolInfo, filters, clearFilter, isFaculty} = this.props;

		let listProps = {
			width: [1, 1 / 4],
			mt: [0, 0],
		};
		if (!columnView) {
			listProps = {
				width: 1,
				mt: [0, 3]
			}
		}

		let showUserList = true;
		let showToolbar = true;
		let showDetails = columnView;
		if (detailsView) {
			showToolbar = false;
			showUserList = false;
			showDetails = true
		}
		if (columnView) {
			showToolbar = true;
			showUserList = true;
			showDetails = true
		}
		const showSummary = ( showDetails);
		let searchList = filterStudentsByName(students, search);

		return (
			<Fragment>
				{/* DESKTOP Toolbar with Filters and Column/Grid View*/}
				<DesktopBox>
					{showToolbar &&
					<Toolbar p={2} bg={'white'} boxShadow={['none', 'main']}>
						<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
						                                                  color={'meta'}>VIEW</Text></Box>
						<Box bg={'transparent'} ml={3} py={2}
						     onClick={() => this.setState({columnView: false, detailsView: false})}>
							<GridIcon color={!columnView ? 'black' : '#969a9b'}/>
						</Box>
						<Box ml={2} py={2} onClick={() => this.setState({columnView: true})}>
							<ColumnIcon color={columnView ? '#00000' : '#969a9b'}/>
						</Box>
						<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
						                                                  color={'meta'}>FILTER</Text></Box>
						<Box ml={3}>
							<FilterDropdown school={schoolInfo} filters={filters} clearFilter={clearFilter} dormView/>
						</Box>
						<Box ml={'auto'}/>
						<Box><SearchInput/></Box>
					</Toolbar>
					}
				</DesktopBox>
				{(loading || isLoading) ? <Loading/> :
					<Flex width={1}>
						{showUserList &&
						<SidebarBox {...listProps} css={{minWidth: '250px'}}>
							<SidebarWrapper boxShadow={['none', columnView ? 'inset' : 'none']} pb={[50, 0]}>
								<UserList students={searchList} handleUserClick={this.handleSelectStudent} withLocation
								          columnView={columnView} infiteScroll current={currentStudent ? currentStudent.id : '1'}/>
							</SidebarWrapper>
						</SidebarBox>}
						{showSummary ?
							<StudentSummary student={currentStudent} showBack={!showToolbar} isFaculty={isFaculty}
											handleBack={() => 
												this.setState({
													detailsView: false,
													showCheckin: true,
													isStudenSummary: false
												})} profile={profile}/>
							: <Box/>
						}
					</Flex>}
			</Fragment>
		)
	}

	renderCheckin = () => {
		const {currentCheckin, showCheckin, title, isCheckin, draftCheckIn, isLoading} = this.state;
		const { search, students, loading} = this.props;
		let studentList = students
		if(currentCheckin){
			studentList = students.filter(student => currentCheckin.all.includes(student.id))
		}

		let searchList = filterStudentsByName(studentList, search);

		// let isLoading = !loading && !loadingSchool
		return (
			<Fragment>
				{!loading && showCheckin && !isLoading &&
			<Checkin visible={showCheckin} handleSave={this.handleUpdateCheckin}
					 handleDiscard={this.handleCheckinDiscard}
					 draftSelected={isCheckin ? draftCheckIn : []}
					 handleSelectStudent={this.handleSelectStudent}
			         toggleVisible={() => this.setState({showCheckin: false})} students={searchList}
			         title={title} previous={currentCheckin}/>}
			</Fragment>
		)
	}
}

export default CheckinPage;
